<template>
    <tr
        class="border-b dark:border-gray-700"
        :class="hasError ? 'bg-red-100 dark:bg-red-900 dark:bg-opacity-30' : ''">
        <td  class="p-2 text-xs">
        <span v-html="product.name ?? '-'"></span>
            <!--{{ product.name ?? '-' }}-->
        </td>
        <td class="p-2 text-xs">
            {{ product.formulator_name ? product.formulator_name : '-'  }}
        </td>
        <!-- Come la cella del Product Id: la riga rossa dice che qualcosa non
             va, la cella evidenziata dice **quale** valore correggere. -->
        <td class="p-2 text-xs" :class="hasInvalidQuantity ? 'text-red-900 dark:text-red-300 font-semibold' : ''">
            {{ product.quantity ? product.quantity : '-' }}
        </td>
        <td class="p-2 text-xs">
            {{ product.reference_date ? product.reference_date : '-' }}
        </td>
        <!-- La cella malformata resta evidenziata anche sulla riga rossa: dice
             quale valore correggere, che il colore della riga da solo non dice. -->
        <td class="p-2 text-xs" :class="product.invalid_reference_id ? 'text-red-900 dark:text-red-300 font-semibold' : ''">
            {{ product.declared_reference_id ? product.declared_reference_id : '-' }}
        </td>
        <td class="p-2 text-xs">
            <div class="flex items-center space-x-1">
                <span v-if="product.status === true" class="text-green-500">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 fill-current" aria-hidden="true" focusable="false">
                        <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"/>
                    </svg>
                </span>
                <!-- L'icona da sola non dice cosa correggere: il messaggio sta
                     nel popup, perche' accanto alla riga rubava la larghezza
                     alle colonne del prodotto. -->
                <button
                    v-else-if="setErrorKey"
                    type="button"
                    :title="$t('importModal.errors.show', $store.state.locale)"
                    :aria-label="$t('importModal.errors.show', $store.state.locale)"
                    @click.prevent="$emit('showError', setErrorKey)"
                    class="flex items-center justify-center text-red-700 dark:text-red-300 hover:text-red-900 dark:hover:text-red-200 duration-300">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 fill-current" aria-hidden="true" focusable="false">
                        <path d="M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.009,8.009,0,0,1,12,20Zm.5-3.5a.75.75,0,1,1-.75-.75A.75.75,0,0,1,12.5,16.5ZM11.75,6.5a3,3,0,0,0-3,3,1,1,0,0,0,2,0,1,1,0,1,1,1,1,1,1,0,0,0-1,1v1.25a1,1,0,0,0,2,0v-.42a3,3,0,0,0-1-5.83Z"/>
                    </svg>
                </button>
            </div>
        </td>
    </tr>
</template> 
<script>
import { computed } from 'vue';
import moment from 'moment';
export default 
{
    props:
    {
        product:{ required: true }
    },
    emits: ['showError'],
    setup(props)
    {
        /**
         *
         * Computed
         *
         */
        /**
         * La riga e' in errore, e va colorata tutta.
         *
         * Sono due momenti diversi che valgono lo stesso per chi guarda: la riga
         * che non passa i controlli sul file — e che quindi non partira' — e
         * quella che l'api ha rifiutato dopo l'invio. Prima solo la prima era
         * rossa, e una riga rifiutata restava bianca con una crocetta in fondo.
         */
        const hasError = computed( () => 
        {
            if(props.product.status === false) return true;

            return !props.product.name  
                || !props.product.formulator_name
                || !props.product.quantity
                || props.product.invalid_reference_id
                || !props.product.reference_date || !moment(props.product.reference_date, 'DD-MM-YYYY').isValid();
        }); 
        /**
         * Il messaggio da mostrare nel popup, se c'e'.
         *
         * Un id malformato si vede prima di inviare, quindi non aspetta lo stato:
         * la riga e' gia' esclusa dall'import e all'utente serve sapere quale
         * cella correggere. Gli altri codici arrivano dall'api; quelli non
         * mappati restano generici invece di far comparire a schermo il codice.
         */
        const setErrorKey = computed( () => 
        {
            if(props.product.invalid_reference_id) return 'importModal.errors.invalid_reference_id';
            if(props.product.status !== false) return null;
            if(props.product.error === 'reference_id_name_mismatch') return 'importModal.errors.reference_id_name_mismatch';
            if(props.product.error === 'invalid_quantity') return 'importModal.errors.invalid_quantity';
            return 'importModal.errors.generic';
        });

        /**
         * La quantita' e' la cella che l'api ha rifiutato.
         *
         * Guarda lo stesso codice del messaggio, non il valore: una quantita'
         * negativa e' scritta bene nel file — e' il dominio che non l'accetta —
         * quindi qui non c'e' niente da ricontrollare da soli, solo da riportare.
         */
        const hasInvalidQuantity = computed( () => props.product.error === 'invalid_quantity');

        return {
            /* Computed */
            hasError,
            setErrorKey,
            hasInvalidQuantity
        }
    }
}
</script>
